module.exports = __webpack_public_path__ + "img/correo.b8f11fdf.png";